<script>
  import { createEventDispatcher } from "svelte";
  import { currentLanguage } from "../../store";
  import translations from "../../translations";

  const dispatch = createEventDispatcher();

  export let maximum = 1;
  export let minimum = 1;
  export let value = 1;
  export let label = null;

  let currentLang = navigator.language.split("-")[0] || "en";
  let quantity = value;
  let error = "";
  $: attendeesLabel = typeof label === "string" && label.trim()
    ? label.trim()
    : translations.numberOfAttendees[currentLang] || translations.numberOfAttendees.en;

  currentLanguage.subscribe((value) => {
    currentLang = value;
  });

  const handleSubmit = () => {
    const parsedQuantity = Number(quantity);

    if (!Number.isInteger(parsedQuantity) || parsedQuantity < minimum) {
      error = (translations.minAmountValidationText[currentLang] || translations.minAmountValidationText.en).replace("{min}", minimum);
      return;
    }

    if (parsedQuantity > maximum) {
      error = (translations.maxAmountValidationText[currentLang] || translations.maxAmountValidationText.en).replace("{max}", maximum);
      return;
    }

    error = "";
    dispatch("submit", parsedQuantity);
  };

  const handleKeydown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };
</script>

<div class="chatwith-booking-form chatwith-booking-quantity">
  <div class="chatwith-booking-form-fields">
    <div class="chatwith-booking-form-label">{attendeesLabel}</div>
    <div class="chatwith-booking-form-input">
      <input
        type="number"
        min={minimum}
        max={maximum}
        step="1"
        bind:value={quantity}
        on:keydown={handleKeydown}
        aria-invalid={error ? "true" : "false"}
      />
    </div>
    {#if error}
      <div class="chatwith-booking-quantity-error">{error}</div>
    {/if}
    <div class="chatwith-booking-form-btn-container">
      <button type="button" class="chatwith-booking-form-btn" on:click={handleSubmit}>
        {translations.confirm[currentLang] || translations.confirm.en}
      </button>
    </div>
  </div>
</div>
